module.exports = __webpack_public_path__ + "static/media/printStep3.ea81c279.png";